
import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import {
    Input, Button, Form, Select, Label
} from 'semantic-ui-react';
import Swal from '#/swal';
import { roles as roleNames } from '#/constants';
import { useUpdateUser, useCreateUser } from '~/user';

const roles = [
    {
        value: roleNames.admin,
        text: 'Admin'
    },
    {
        value: roleNames.user,
        text: 'User'
    },
    {
        value: roleNames.legal,
        text: 'Legal'
    },
    {
        value: roleNames.legal_admin,
        text: 'Legal Admin'
    },
    {
        value: roleNames.regional_manager_admin,
        text: 'Regional Manager Admin'
    },
    {
        value: roleNames.executive_assistant,
        text: 'Executive Assistant'
    },
    {
        value: roleNames.pricing_analyst,
        text: 'Pricing Analyst'
    }
];


const UserForm = props => {

    const { mutate: updateUser } = useUpdateUser();
    const { mutate: createUser } = useCreateUser();


    const onSubmit = async values => {


        if (values.scope.includes('admin')) {
            props.closeModal();

            const { value } = await Swal.fire.warning({ text: 'Admins have FULL access to all properties and data' });

            if (!value) {
                return;
            }
        }

        values.confirmed = true;

        if (props.initialValues) {
            updateUser(values);
        }
        else {

            createUser(values);
        }

        props.closeModal();

    };

    return (
        <FinalForm
            validate={validate}
            onSubmit={onSubmit}
            initialValues={props.initialValues}
            render={({ handleSubmit, submitting, pristine }) => (
                <Form onSubmit={handleSubmit} autoComplete='off'>
                    <Field name='name'>
                        {({ input, meta }) => (
                            <Form.Field>
                                <label htmlFor='name'>Full Name</label>
                                <Input placeholder='Full Name' {...input} />
                                {meta.error && meta.touched && <Label basic color='red' pointing>{meta.error}</Label>}
                            </Form.Field>
                        )}
                    </Field>

                    {!props.initialValues && (

                        <Field name='email'>
                            {({ input, meta }) => (
                                <Form.Field>
                                    <label htmlFor='email'>Email</label>
                                    <Input autoComplete='off' placeholder='Email Address' {...input} />
                                    {meta.error && meta.touched && <Label basic color='red' pointing>{meta.error}</Label>}
                                </Form.Field>
                            )}
                        </Field>
                    )}

                    <Field name='scope'>
                        {({ input, meta }) => (
                            <Form.Field>
                                <label htmlFor='scope'>Choose Role</label>
                                <Select
                                    {...input}
                                    onChange={((e, t) => input.onChange(t.value))}
                                    placeholder='Select Role'
                                    options={roles}
                                />
                                {meta.error && meta.touched && <Label basic color='red' pointing>{meta.error}</Label>}
                            </Form.Field>
                        )}
                    </Field>

                    <Form.Field>
                        <Button
                            compact
                            negative
                            onClick={e => {
                                e.preventDefault();
                                props.closeModal();
                            }}>
                            Cancel
                        </Button>
                        <Button
                            compact
                            floated='right'
                            positive
                            type='submit'
                            disabled={submitting || pristine}>
                            Submit
                        </Button>
                    </Form.Field>
                </Form>
            )}
        />
    );
};

const validate = values => {
    const errors = {};
    if (!values.name) {
        errors.name = 'Required';
    }
    if (!values.email) {
        errors.email = 'Required';
    }
    if (!values.scope) {
        errors.scope = 'Required';
    }

    return errors;
};


export default UserForm;
